import React, { useState, useRef, useEffect } from "react";

const BalleteIcon = () => {
  const divRef = useRef(null);

  const [strokeColor, setStrokeColor] = useState("#B4C0C8");

  const handleClick = () => {
    setStrokeColor("#1D4469");
  };

  const handleOutsideClick = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setStrokeColor("#B4C0C8");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={divRef}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        onClick={handleClick}
      >
        <rect x="0.5" y="0.5" width="33" height="33" rx="6.5" stroke={strokeColor} />
        <path
          d="M24.318 16.6723V14.5641C24.318 13.8492 23.7635 13.2678 23.0629 13.2114L21.105 9.79174C20.9236 9.47547 20.6306 9.24942 20.2801 9.15555C19.9312 9.06233 19.5663 9.11129 19.254 9.29305L12.5424 13.2004H11.3636C10.6116 13.2004 10 13.812 10 14.5641V22.7458C10 23.4978 10.6115 24.1094 11.3636 24.1094H22.9544C23.7064 24.1094 24.318 23.4978 24.318 22.7458V20.6375C24.7139 20.4963 24.9998 20.1215 24.9998 19.6776V17.6322C24.9998 17.1883 24.7139 16.8135 24.318 16.6723ZM22.2706 13.2004H19.2993L21.5278 11.903L22.2706 13.2004ZM21.1891 11.3113L17.9443 13.2004H16.5983L20.8526 10.7236L21.1891 11.3113ZM19.5972 9.88229C19.7514 9.79206 19.9315 9.76809 20.1036 9.81405C20.2777 9.86065 20.4229 9.97318 20.5131 10.1306L20.5138 10.1319L15.2433 13.2004H13.8975L19.5972 9.88229ZM23.6362 22.7458C23.6362 23.1216 23.3302 23.4275 22.9544 23.4275H11.3636C10.9878 23.4275 10.6818 23.1216 10.6818 22.7458V14.5641C10.6818 14.1882 10.9878 13.8823 11.3636 13.8823H22.9544C23.3302 13.8823 23.6362 14.1882 23.6362 14.5641V16.6095H21.5907C20.4628 16.6095 19.5453 17.527 19.5453 18.6549C19.5453 19.7828 20.4628 20.7003 21.5907 20.7003H23.6362V22.7458ZM24.318 19.6776C24.318 19.8657 24.1652 20.0185 23.9771 20.0185H21.5907C20.8387 20.0185 20.2271 19.407 20.2271 18.6549C20.2271 17.9029 20.8387 17.2913 21.5907 17.2913H23.9771C24.1652 17.2913 24.318 17.4441 24.318 17.6322V19.6776Z"
          fill="none"
          stroke={strokeColor}
        />
        <path
          d="M21.5907 17.9731C21.2149 17.9731 20.9089 18.2791 20.9089 18.6549C20.9089 19.0308 21.2149 19.3367 21.5907 19.3367C21.9666 19.3367 22.2725 19.0308 22.2725 18.6549C22.2726 18.2791 21.9666 17.9731 21.5907 17.9731Z"
          fill={strokeColor}
        />
      </svg>
    </div>
  );
};

export default BalleteIcon;
